import { useCallback, useEffect } from 'react';

import type { FilterQuery } from 'Types/filter';

import useReplaceVehicleListUrl from '../useReplaceVehicleListUrl/useReplaceVehicleListUrl';
import { useClearVehicleListCache } from '../useVehicleListCache/useClearVehicleListCache';

export interface UseRefreshVehicleListParams extends Partial<FilterQuery> {
	isReplaceVehicleListUrl: boolean;
	refetch: () => void;
}

export type UseRefreshVehicleList = () => void;

const useRefreshVehicleList = ({
	asUrlPath,
	displayUrl,
	isReplaceVehicleListUrl,
	refetch,
}: UseRefreshVehicleListParams): UseRefreshVehicleList => {
	const replaceVehicleListUrl = useReplaceVehicleListUrl({ asUrlPath, displayUrl });
	const { clearAllVehicleListCache } = useClearVehicleListCache();

	const onRefresh = useCallback(() => {
		replaceVehicleListUrl();
		clearAllVehicleListCache();
		refetch();
	}, [replaceVehicleListUrl, refetch, clearAllVehicleListCache]);

	useEffect(() => {
		if (isReplaceVehicleListUrl) {
			replaceVehicleListUrl();
		}
	}, [replaceVehicleListUrl, isReplaceVehicleListUrl]);

	return onRefresh;
};

export default useRefreshVehicleList;
